import React from "react";
import SecondaryButton from "../buttons/SecondaryButton";
import { Divider, Switch } from "@mui/material";
import Space from "../layout/Space";

import RoundedButton2 from "../buttons/RoundedButton2";
import Icon1 from "../icons/Icon";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useEffect } from "react";
import { useAuth } from "../auth/FirebaseAuth";
import { getUserById } from "../models/UserFunctions";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import stripeSubscriptionManager from "../api/stripe/stripeSubscriptionManager";
import { useAppContext } from "../config/AppContext";

import Accordion2 from "../layout/Accordion2";
import { EasySwitch } from "../textfields/EasySwitch";
import PlanComparison from "./PlanComparison";

const PlanLine = ({ title, text_color = "text-black" }) => {
  return (
    <div className="flex flex-row gap-2">
      <Icon1 icon_name="done" height="16px" width="16px" />
      <div className={`text-h3 ${text_color}`}>{title}</div>
    </div>
  );
};

function getPrice(plan, engagement, test_env = false) {
  if (plan === "free_tier") {
    return "0€";
  } else if (plan === "business" && engagement === "month") {
    return test_env ? "1€" : "90€";
  } else if (plan === "business" && engagement === "year") {
    return test_env ? "1€" : "75€";
  } else if (plan === "premium" && engagement === "month") {
    return test_env ? "2€" : "180€";
  } else if (plan === "premium" && engagement === "year") {
    return test_env ? "2€" : "150€";
  } else if (plan === "starter" && engagement === "month") {
    return test_env ? "2€" : "35€";
  } else if (plan === "starter" && engagement === "year") {
    return test_env ? "2€" : "29€";
  }
}

const PlanMarket = ({ onClose }) => {
  const [plan, setPlan] = useState("free_tier");
  const [engagement, setEngagement] = useState(true);
  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [questions, setQuestions] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const handlePlanChange = async (plan, engagement) => {
    const token = await getOrRefreshFirebaseToken();
    const url = await stripeSubscriptionManager(
      plan,
      engagement,
      null,
      null,

      token,
      prefix
    );
    if (url === "done") {
      handleClickVariant("Plan changé avec succès", "success");
      handleFetchData();
    } else {
      // open new window and launch url
      window.open(url, "_blank");
    }
  };

  const handleFetchData = async () => {
    if (currentUser) {
      try {
        const user = await getUserById(currentUser.uid);
        const org = await getOrgById(user.org_id);

        setUserData(user);
        setOrgData(org);
        setEngagement(
          org.facturation?.engagement === "year"
            ? true
            : org.facturation?.engagement === "month"
              ? false
              : true
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  if (loading || !currentUser || !userData) {
    return <> Loading ..</>;
  }

  return (
    <div className="relative   flex flex-col     bg-black h-screen w-full rounded-lg items-center justify-start">
      <div className="fixed flex top-0  right-0 w-full">
        <img
          src="https://products.ls.graphics/mesh-gradients/images/29.-Pale-Cornflower-Blue_1.jpg"
          className=" object-fill opacity-100 w-full h-full  "
        />
      </div>
      <div className="z-10 overflow-auto pb-10 flex flex-col h-fit  items-center w-full bg-gradient-to-t from-transparent to-wshadow_50 rounded-lg p-4">
        <div className="flex flex-row justify-end w-full  h-full">
          <SecondaryButton onClick={onClose}>Fermer</SecondaryButton>
        </div>
        <div className="text-hx4  font-semibold text-center">
          Plans de facturation
        </div>
        <div className="border-1 bg-white gap-4 mt-10 border-shadow_25 rounded-3xl p-3  flex flex-row justify-center items-center w-fit">
          <EasySwitch
            checked={engagement}
            onChange={() => setEngagement(!engagement)}
          />
          <div className="text-h2">Annuel (-20%) </div>
        </div>
        <div className="flex flex-row justify-center items-start gap-4 w-full max-w-c1k mt-10">
          <div className="bg-white border-2 border-black rounded-3xl flex flex-col h-fit p-8 w-full shadow-xl">
            <div className="relative flex -top-3 items-center justify-center rounded-full px-2  w-full">
              <div className=" absolute -top-7 bg-black rounded-full flex px-2 py-0.5 w-fit">
                <div className="text-h4 text-f_white">Recommandé</div>
              </div>
            </div>
            <div className="text-hx2 font-bold">Premium</div>
            <Space y={5} />
            <div className="text-h3 ">La package complet</div>
            <Space y={10} />
            <div className="text-hx2 ">
              {getPrice(
                "premium",
                engagement ? "year" : "month",
                orgData.facturation?.test_env
              )}
              <span className="text-h2 text-shadow_50">
                {" "}
                /utilisateur/mois HT
              </span>
            </div>
            <Space y={10} />

            <PlanButton>Contactez le - 06 51 02 24 62</PlanButton>
          </div>
          <div className="bg-black border-2 border-black text-white rounded-3xl flex flex-col h-fit p-8 w-full shadow-xl">
            <div className="relative flex -top-3 items-center justify-center rounded-full px-2  w-full"></div>
            <div className="text-hx2 font-bold">Entreprise</div>
            <Space y={5} />
            <div className="text-h2 ">Plan sur mesure</div>
            <Space y={10} />
            <div className="text-h3 mb-6 ">
              Pour les entreprises de plus de 6 opérateurs
            </div>

            <PlanButton white={true}>Contactez le - 06 51 02 24 62</PlanButton>
          </div>
        </div>
        <Space y={40} />
        <PlanComparison></PlanComparison> <Space y={50} />
      </div>
    </div>
  );
};

export default PlanMarket;

const PlanButton = ({ children, onClick, soft, settings = false, white }) => {
  return (
    <div
      className={`w-fit  flex flex-row gap-2 items-center rounded-lg px-5 py-2 text-h2 cursor-pointer  hover:shadow-lg ${children == "Gérer le plan" || white ? "bg-white text-black border-1 border-shadow_25" : "bg-black text-white"}`}
      onClick={onClick}
    >
      {children}
      {children == "Gérer le plan" && (
        <Icon1 icon_name="settings" fill="black" size={18} />
      )}
    </div>
  );
};

function getModifText(old_plan, old_engagement, new_plan, new_engagement) {
  if (old_plan === new_plan && old_engagement === new_engagement) {
    return "Gérer le plan";
  } else if (old_plan === new_plan && old_engagement !== new_engagement) {
    return (
      "Passer en " + (new_engagement === "year" ? "annuel (-20%)" : "mensuel")
    );
  }
  return "Passer au plan " + new_plan;
}
